import { Button } from '@/components/UI/Button'
import { Dialog } from '@/components/UI/Dialog'
import { Switch } from '@/components/UI/Switch'
import { useTranslation } from 'react-i18next'

type FrameItem = {
  index: number
  label: string
  thumbnailUrl: string
  visible: boolean
}

type FrameSettingsDialogProps = {
  open: boolean
  onClose: () => void
  frames: FrameItem[]
  onToggleFrame: (index: number, visible: boolean) => void
  onReset: () => void
}

export const FrameSettingsDialog = ({ open, onClose, frames, onToggleFrame, onReset }: FrameSettingsDialogProps) => {
  const { t } = useTranslation()

  return (
    <Dialog
      selectorState={open}
      closeFunc={onClose}
      showCloseButton
      title={t('spot_detail.ar.frame_settings_title', 'ARフォトフレームの設定')}
    >
      <div className="flex flex-col items-center">
        {/* 説明 */}
        <p className="text-[12px] text-black text-center mt-2 leading-[16px]">
          {t('spot_detail.ar.frame_settings_description', '画像の表示/非表示とリセットが行えます')}
        </p>

        {/* フレームリスト */}
        {frames.length > 0 && (
          <div className="w-full mt-6 flex flex-col gap-4">
            {frames.map((frame) => (
              <div key={frame.index} className="flex items-center justify-between w-full">
                <span className="font-bold text-[16px] text-black leading-[24px]">{frame.label}</span>
                <div className="flex items-center gap-3">
                  <img
                    src={frame.thumbnailUrl}
                    alt={frame.label}
                    className="size-[30px] rounded object-cover bg-[#d9d9d9]"
                  />
                  <Switch
                    checked={frame.visible}
                    onChange={(checked) => onToggleFrame(frame.index, checked)}
                    color="var(--main-color)"
                  />
                </div>
              </div>
            ))}
          </div>
        )}

        {/* ボタン */}
        <div className="mt-6 mb-2 flex items-center justify-center gap-3">
          <Button
            label={t('spot_detail.ar.frame_reset', 'リセットする')}
            variant="system"
            size="md"
            round
            onClick={() => {
              onReset()
            }}
            className="!w-[123px]"
          />
          <Button
            label={t('spot_detail.ar.back_to_camera', '戻る')}
            variant="primary"
            size="md"
            round
            onClick={onClose}
            className="!w-[123px]"
          />
        </div>
      </div>
    </Dialog>
  )
}
